import config from "../../config"
import RequestService from "../RequestService"

const fetchReservationImport = (id, successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrlV2}/reservation_imports/${id}`, successCallback, failureCallback)
}

export default fetchReservationImport;